import React, { useEffect, useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { fetchGroupedOrderDocuments } from "state/prestationRoadSheet/actions";

const apiUrl = process.env.REACT_APP_API_URL;

const AnnexLink = ({ annex, index }) => {
  const name = annex.original_name || annex.originalName || `Document ${index + 1}`;
  return (
    <div>
      {annex.media?.path ? (
        <a href={`${apiUrl}/${annex.media.path}`} target="_blank" rel="noopener noreferrer">
          {name}
        </a>
      ) : (
        name
      )}
      {annex.size ? <small className="text-muted"> ({(annex.size / 1024).toFixed(1)} Ko)</small> : null}
    </div>
  );
};

// Documents consultables par le livreur : annexes de la feuille de route de sa
// prestation, puis celles des autres prestations du même devis (ex. plan d'accès
// déposé sur la presta du midi avec service, utile au livreur du PDJ sans service).
const DeliveryDocuments = ({ order, groupedOrderId }) => {
  const dispatch = useDispatch();
  const [eventOrders, setEventOrders] = useState([]);

  useEffect(() => {
    setEventOrders([]);
    if (!groupedOrderId || !order?.id) {
      return;
    }
    let cancelled = false;
    Promise.resolve(dispatch(fetchGroupedOrderDocuments(groupedOrderId))).then((groupedOrder) => {
      if (cancelled || !Array.isArray(groupedOrder?.orders)) {
        return;
      }
      setEventOrders(
        groupedOrder.orders.filter(
          (o) => parseInt(o.id) !== parseInt(order.id) && o.road_sheet?.annexes?.length > 0
        )
      );
    });
    return () => {
      cancelled = true;
    };
  }, [dispatch, groupedOrderId, order?.id]);

  const ownAnnexes = order?.road_sheet?.annexes || [];

  return (
    <Card className="mt-2">
      <Card.Body>
        <Row noGutters>
          <Col xs={1}>
            <FontAwesomeIcon icon={faPaperclip} />
          </Col>
          <Col xs={11}>
            <b>DOCUMENTS DE LA PRESTATION</b>
            {ownAnnexes.length > 0 ? (
              ownAnnexes.map((annex, index) => (
                <AnnexLink annex={annex} index={index} key={annex.id || index} />
              ))
            ) : (
              <div>Aucun</div>
            )}
            <b className="d-block mt-2">DOCUMENTS DE L'ÉVÉNEMENT</b>
            <small className="d-block text-muted">Autres prestations du même devis</small>
            {eventOrders.length > 0 ? (
              eventOrders.map((o) => (
                <div key={o.id} className="mt-1">
                  <small>
                    <b>
                      {o.prestation_type_fr || "Prestation"}
                      {o.delivery?.delivery_date &&
                        ` du ${moment(o.delivery.delivery_date).format("DD/MM")}`}
                      {o.delivery?.start_at && ` à ${moment(o.delivery.start_at).format("HH:mm")}`}
                    </b>
                  </small>
                  {o.road_sheet.annexes.map((annex, index) => (
                    <AnnexLink annex={annex} index={index} key={annex.id || index} />
                  ))}
                </div>
              ))
            ) : (
              <div>Aucun</div>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default DeliveryDocuments;
